/* --- AVALNA FOOTER — Batch 25 ---------------------------------------------
   Mobile accordion toggle for the Shop and Company columns only.

   Policies, Need Help, the business information strip and the bottom bar are
   never collapsible — they carry Merchant Center remediation content and must
   be visible without interaction (Decision D4).

   Lists render OPEN in the HTML and are collapsed here at init on mobile, so a
   no-JS mobile visitor still sees every link. Breakpoint is decided once at
   init via matchMedia, matching the Batch 18 W2 pattern — no resize re-binding.
   -------------------------------------------------------------------------- */

(function () {
  'use strict';

  var AVALNA_FOOTER_MOBILE = '(max-width: 749px)';

  function avalnaFooterSetExpanded(avalnaToggle, avalnaExpanded) {
    var avalnaList = document.getElementById(avalnaToggle.getAttribute('aria-controls'));
    avalnaToggle.setAttribute('aria-expanded', avalnaExpanded ? 'true' : 'false');
    if (avalnaList) {
      avalnaList.hidden = !avalnaExpanded;
    }
  }

  function avalnaFooterInit() {
    var avalnaFooter = document.querySelector('[data-avalna-footer]');
    if (!avalnaFooter) return;

    var avalnaToggles = avalnaFooter.querySelectorAll('[data-avalna-footer-toggle]');
    if (!avalnaToggles.length) return;

    var avalnaIsMobile = window.matchMedia(AVALNA_FOOTER_MOBILE).matches;

    Array.prototype.forEach.call(avalnaToggles, function (avalnaToggle) {
      if (!avalnaIsMobile) {
        /* Desktop: the heading is not a control. Strip the ARIA so screen
           readers announce plain heading text, and take it out of tab order. */
        avalnaToggle.removeAttribute('aria-expanded');
        avalnaToggle.removeAttribute('aria-controls');
        avalnaToggle.setAttribute('tabindex', '-1');
        return;
      }

      avalnaFooterSetExpanded(avalnaToggle, false);

      avalnaToggle.addEventListener('click', function () {
        var avalnaOpen = avalnaToggle.getAttribute('aria-expanded') === 'true';
        avalnaFooterSetExpanded(avalnaToggle, !avalnaOpen);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaFooterInit);
  } else {
    avalnaFooterInit();
  }
})();
